export default {
      id: "icon-close-fund-usage",
      viewBox: "-4 -3 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-close-fund",
      toString: function () {
        return this.url;
      }
    }